import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Button from '../components/Button';

interface CompanyProfile {
  name: string;
  location: string;
  membershipDate: string;
  followers: number;
  listings: number;
  rating: number;
  positiveFeedback: number;
  about: string;
  profilePhoto: string;
  notifications: number;
  messages: number;
}

const SaticiProfilKurumsal: React.FC = () => {
  const navigate = useNavigate();
  const [profile, setProfile] = useState<CompanyProfile>({
    name: 'Yılmaz Bilgisayar',
    location: 'İstanbul, Kadıköy',
    membershipDate: 'Ocak 2023',
    followers: 1200,
    listings: 127,
    rating: 4.8,
    positiveFeedback: 98,
    about: 'Teknoloji meraklısı, bilgisayar parçaları alım-satımı yapıyorum. 5 yıldır bu sektördeyim. Müşteri memnuniyeti benim için her zaman önceliklidir. Ürünlerimi titizlikle seçiyor ve detaylı testlerden geçiriyorum. Güvenilir alışveriş için doğru adrestesiniz.',
    profilePhoto: '../assets/images/company-logo.png',
    notifications: 3,
    messages: 2
  });

  const [isFollowing, setIsFollowing] = useState(false);

  const handleLogout = () => {
    // Logout logic here
    navigate('/');
  };

  const handleFollow = () => {
    setIsFollowing(!isFollowing);
  };

  const handleSendMessage = () => {
    // Message logic here
    navigate('/mesajlar');
  };

  return (
    <div className="bg-light min-vh-100">
      {/* Header */}
      <header className="header sticky-top bg-white">
        <nav className="navbar navbar-expand-lg">
          <div className="container">
            {/* Logo */}
            <Link className="navbar-brand fw-bold text-primary" to="/">
              <i className="fas fa-laptop me-2" />
              SadeceBilgisayar.com
            </Link>
            {/* Arama Kutusu */}
            <div className="search-box mx-lg-4 flex-grow-1">
              <form className="d-flex">
                <div className="input-group">
                  <input
                    aria-label="Arama"
                    className="form-control"
                    placeholder="Dizüstü, masaüstü, parça ara..."
                    type="search"
                  />
                  <Button className="btn btn-primary" type="submit">
                    <i className="fas fa-search" />
                  </Button>
                </div>
              </form>
            </div>
            {/* Sağ Menü */}
            <div className="nav-right d-flex align-items-center">
              <Link className="btn btn-outline-primary me-3" to="/ilan-ver">
                <i className="fas fa-plus-circle me-2" />
                İlan Ver
              </Link>
              {/* Bildirimler */}
              <div className="dropdown me-3">
                <Button className="btn btn-link text-dark position-relative" data-bs-toggle="dropdown">
                  <i className="fas fa-bell fs-5" />
                  <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger">
                    {profile.notifications}
                  </span>
                </Button>
                <div className="dropdown-menu dropdown-menu-end">
                  <h6 className="dropdown-header">Bildirimler</h6>
                  <Link className="dropdown-item" to="#">
                    İlanınıza yeni bir mesaj geldi
                  </Link>
                  <Link className="dropdown-item" to="#">
                    Takip ettiğiniz ürünün fiyatı düştü
                  </Link>
                  <Link className="dropdown-item" to="#">
                    Yeni bir teklif aldınız
                  </Link>
                </div>
              </div>
              {/* Mesajlar */}
              <div className="dropdown me-3">
                <Button className="btn btn-link text-dark position-relative" data-bs-toggle="dropdown">
                  <i className="fas fa-envelope fs-5" />
                  <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger">
                    {profile.messages}
                  </span>
                </Button>
                <div className="dropdown-menu dropdown-menu-end">
                  <h6 className="dropdown-header">Mesajlar</h6>
                  <Link className="dropdown-item" to="/mesajlar">
                    Tüm mesajları görüntüle
                  </Link>
                </div>
              </div>
              {/* Kullanıcı Menüsü */}
              <div className="dropdown">
                <Button className="btn btn-link text-dark dropdown-toggle d-flex align-items-center" data-bs-toggle="dropdown">
                  <img
                    alt="Şirket Logo"
                    className="rounded-circle me-2"
                    height="32"
                    src={profile.profilePhoto}
                    width="32"
                  />
                  <span>{profile.name}</span>
                </Button>
                <ul className="dropdown-menu dropdown-menu-end">
                  <li>
                    <Link className="dropdown-item" to="/profil-kurumsal">
                      <i className="fas fa-building me-2" />
                      Şirket Profili
                    </Link>
                  </li>
                  <li>
                    <Link className="dropdown-item" to="/ilanlarim-kurumsal">
                      <i className="fas fa-list me-2" />
                      İlanlarım
                    </Link>
                  </li>
                  <li>
                    <Link className="dropdown-item" to="/favoriler-kurumsal">
                      <i className="fas fa-heart me-2" />
                      Favorilerim
                    </Link>
                  </li>
                  <li>
                    <hr className="dropdown-divider" />
                  </li>
                  <li>
                    <Button className="dropdown-item" onClick={handleLogout}>
                      <i className="fas fa-sign-out-alt me-2" />
                      Çıkış Yap
                    </Button>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </nav>
      </header>

      <main className="container py-4">
        {/* Satıcı Profil Kartı */}
        <div className="card mb-4">
          <div className="card-body">
            <div className="row align-items-center">
              <div className="col-md-2 text-center">
                <img
                  alt="Satıcı"
                  className="rounded-circle mb-3"
                  height="150"
                  src={profile.profilePhoto}
                  width="150"
                />
              </div>
              <div className="col-md-6">
                <h4 className="mb-1">{profile.name}</h4>
                <p className="text-muted mb-2">
                  <i className="fas fa-map-marker-alt me-2" />
                  {profile.location}
                </p>
                <p className="text-muted mb-3">
                  <i className="fas fa-user-clock me-2" />
                  Üye: {profile.membershipDate}
                </p>
                {/* Takipçi Sayısı */}
                <p className="mb-3">
                  <span className="badge bg-light text-dark border">
                    <i className="fas fa-users me-1" />
                    <strong>{profile.followers}</strong> Takipçi
                  </span>
                </p>
                <div className="d-flex gap-2">
                  <Button className="btn btn-primary" onClick={handleSendMessage}>
                    <i className="fas fa-envelope me-2" />
                    Mesaj Gönder
                  </Button>
                  {/* Takip Et Butonu */}
                  <Button
                    className={`btn ${isFollowing ? 'btn-primary' : 'btn-outline-primary'}`}
                    onClick={handleFollow}
                  >
                    <i className={`fas ${isFollowing ? 'fa-user-check' : 'fa-user-plus'} me-2`} />
                    {isFollowing ? 'Takip Ediliyor' : 'Takip Et'}
                  </Button>
                </div>
              </div>
              <div className="col-md-4">
                <div className="stats text-center">
                  <div className="row g-3">
                    <div className="col-4">
                      <h5>{profile.listings}</h5>
                      <small className="text-muted">İlan</small>
                    </div>
                    <div className="col-4">
                      <h5>{profile.rating}</h5>
                      <div className="text-warning">
                        <i className="fas fa-star" />
                      </div>
                    </div>
                    <div className="col-4">
                      <h5>{profile.positiveFeedback}%</h5>
                      <small className="text-muted">Olumlu</small>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Hakkında Bölümü */}
        <div className="card mb-4">
          <div className="card-header bg-light">
            <h5 className="card-title mb-0">
              <i className="fas fa-user me-2 text-primary" />
              Hakkında
            </h5>
          </div>
          <div className="card-body">
            <div className="row">
              <div className="col-md-12">
                <p className="text-muted">{profile.about}</p>
              </div>
            </div>
          </div>
        </div>

        {/* Aktif İlanlar */}
        <h4 className="mb-3">Aktif İlanları</h4>
        <div className="row g-4 mb-4">
          {/* İlan Kartı 1 */}
          <div className="col-md-6 col-lg-4">
            <div className="card h-100">
              <img
                alt="Ürün"
                className="card-img-top"
                src="../assets/images/tr_img_1_20.jpg"
              />
              <div className="card-body">
                <h5 className="card-title">MSI Gaming Laptop</h5>
                <div className="specs-list mb-3">
                  <div className="spec-item">
                    <i className="fas fa-microchip text-primary me-2" />
                    <span>Intel i7-12700H</span>
                  </div>
                  <div className="spec-item">
                    <i className="fas fa-memory text-primary me-2" />
                    <span>16GB RAM</span>
                  </div>
                </div>
                <div className="d-flex justify-content-between align-items-center">
                  <h5 className="text-primary mb-0">25.000 TL</h5>
                  <Link to="/ilan-detay" className="btn btn-outline-primary">
                    İncele
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default SaticiProfilKurumsal;
